<template>
	<div>
		<div class="column">
			<!-- <div class="wrap">
				<div class="search">
					<input type="text" class="searchTerm" placeholder="Search blogs...">
					<button type="submit" class="searchButton">
						Search
					</button>
				</div>
			</div> -->
		</div>
		<div class="column">
			<h1>blog.</h1>
		</div>
		<div v-if="false" class="column">
			<button id='create' type="button" @click="write">Post</button>
		</div>
		<div v-if="state.posts" class="posts-container">
			<div id="posts" v-for="post in state.posts" :key="post.id">
				<router-link :to="{ name: 'BlogReader', params: { id: post.id }}">
					<div>
						<h3>By: {{ post.author }}</h3>
						<h5>{{ formatDate(post.created_date) }}</h5>
						<p>{{ post.summary }}</p>
					</div>
				</router-link>
			</div>
		</div>
		<h2 v-else class="no-posts">no posts.</h2>
	</div>
</template>

<script>
import { useRouter } from 'vue-router'
import { computed, onMounted, reactive } from 'vue'
import { useStore } from 'vuex'
import postService from '../services/PostDataService'

export default {
	name: 'Blog',
	setup() {
		const store = useStore()
		const router = useRouter()
		const write = () => router.push('/write')
		const isAdmin = computed(() => store.state.admin)

		const state = reactive({
			posts: [],
		})

		function formatDate(pass) {
			return new Date(pass).toDateString().split(' ').splice(-3, 3).join(' ')
		}

		onMounted(() => {
			console.log('Calling post api')
			postService.getAll().then(res => {
				state.posts = res.data.Items
				console.log(res)
			}).catch(err => console.log(err));
			console.log('Api done')
		})

		return {
			state,
			write,
			formatDate,
			isAdmin
		}
	}
}
</script>

<style scoped>

#posts {
	width: 90%;
	margin: 10pt auto;
	padding: 5pt;
	border: 1pt solid white;
	border-radius: 10pt;
	max-height: 100pt;
	overflow: hidden;
	transition: 0.5s;
}

#posts:hover {
	width: 95%;
	max-height: 110pt;
}

.column {
	float: left;
	width: 33.33%;
	/* border: dashed red; */
	min-height: 70pt;
	position: relative;
}

#create {
	position: absolute;
	top: 50%;
	border-radius: 10pt;
	width: 100pt;
	height: 25pt;
}

.no-posts {
	position: absolute;
	top: 400pt;
	width: 100%;
}

/* Search bar */

button{
  background: white;
}

.search {
  width: 100%;
  position: relative;
  display: flex;
}

.searchTerm {
  width: 100%;
  border-right: none;
  padding: 5px;
  height: 20px;
  border-radius: 5px 0 0 5px;
  outline: none;
  color: white
}

.searchTerm:focus{
  color: black;
}

.searchButton {
  width: 80px;
  height: 36px;
  background: black;
  text-align: center;
  color: #fff;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 20px;
}

/*Resize the wrap to see the search bar change!*/
.wrap{
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

</style>